// extracted by mini-css-extract-plugin
export default {"SearchPanel":"qb_a bih_ea bih_ke bih_ju bih_a bih_j bih_so bih_sp","SearchPanel__icon":"qb_b bih_vo bih_hi bih_su bih_va","SearchPanel__input":"qb_c bih_jb bih_eg bih_z"};